module.exports = __webpack_public_path__ + "about-colorful-plants.jpg?0ff3ab68f2b431a91d7f4949b0f13b11";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-colorful-plants.jpg
// module id = 332
// module chunks = 0